import type { FC } from 'react';

type PriceProps = {
  price: string;
  isWaiting: boolean;
};

const Price: FC<PriceProps> = ({ price, isWaiting }) =>
  isWaiting ? (
    <div
      className="waviy"
      dangerouslySetInnerHTML={{
        __html: `
        <span style="--i:1">.</span>
        <span style="--i:2">.</span>
        <span style="--i:3">.</span>
      `,
      }}
    />
  ) : (
    <span className="marker-content">{price}</span>
  );

export default Price;
